<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6" sm="8">
          <b-card no-body class="mx-4">
            <b-card-body class="p-4">
              <h1>Registro CEC</h1>
              <p class="text-muted">Alterar Senha</p>
              <b-input-group class="mb-3">
                <b-input-group-prepend>
                  <b-input-group-text><i class="icon-user"></i></b-input-group-text>
                </b-input-group-prepend>
                <input type="text" class="form-control" :disabled="true" v-model="usuario.login" placeholder="login do Usuário">
              </b-input-group>

              <b-input-group class="mb-3">
                <b-input-group-prepend>
                  <b-input-group-text><i class="icon-lock"></i></b-input-group-text>
                </b-input-group-prepend>
                <input type="password" class="form-control" :autocomplete="off" v-model="usuario.senha" placeholder="Senha atual">
              </b-input-group>

              <b-input-group class="mb-3">
                <b-input-group-prepend>
                  <b-input-group-text><i class="icon-lock"></i></b-input-group-text>
                </b-input-group-prepend>
                <input type="password" class="form-control" v-model="usuario.novaSenha" placeholder="Nova Senha">
              </b-input-group>

              <b-input-group class="mb-4">
                <b-input-group-prepend>
                  <b-input-group-text><i class="icon-lock"></i></b-input-group-text>
                </b-input-group-prepend>
                <input type="password" class="form-control" v-model="usuario.novaSenhaConfirmar" placeholder="Repetir Nova Senha">
              </b-input-group>

              <b-button variant="success" block @click.stop.prevent="validar()">Alterar Senha</b-button>
              <b-button variant="outline-info" block @click.stop.prevent="$router.go(-1)">Voltar</b-button>
            </b-card-body>
            
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Tools from '@/tools/tools.js'

export default {
  
  name: 'Register',
  data() {
    return {
      off: false,
      usuario: {
        login:'',
        senha: null,
        novaSenha: null,
        novaSenhaConfirmar: null
      }
    }
  },
  methods: {
    async validar(){
      if (this.usuario.novaSenha != this.usuario.novaSenhaConfirmar) {
        this.$root.$bvToast.toast(`As novas senhas devem ser iguais!!!`, {
          title: 'Aviso',
          autoHideDelay: 2000,
          variant: 'warning',
          appendToast: true
        })
        return
      }
      if ((this.usuario.novaSenha == null) || (this.usuario.novaSenha.length < 4)) {
        this.$root.$bvToast.toast(`A nova senha deve conter pelo menso 4 digitos!!!`, {
          title: 'Aviso',
          autoHideDelay: 2000,
          variant: 'warning',
          appendToast: true
        })
        return
      }
      
      this.$store.commit('controle/setAguardando', true)
      try {
        
        await this.$http.post('/api/protected/usuario/alterarSenhaUC',this.usuario)
      } catch (err) {
        let mensagem = ''
        if (err && err.response && err.response.data != null) {
          if (err && err.response && err.response.data != null) {
            if (typeof err.response.data === 'string') {
              mensagem = err.response.data
            } else if (err.response.data.message) {
              mensagem = err.response.data.message
            } else {
              mensagem = JSON.stringify(err.response.data)
            }
          } else if (typeof err === 'string') {
            mensagem = err
          } else if (err && err.message) {
            mensagem = err.message
          } else {
            mensagem = 'Erro desconhecido'
          }
        }
        
        this.$root.$bvToast.toast(mensagem, {
          title: 'Aviso',
          autoHideDelay: 2000,
          variant: 'warning',
          appendToast: true
        })
        return
      }

      this.$store.commit('controle/setAguardando', false)
      this.$root.$bvToast.toast(`Senha alterada com sucesso!!!`, {
          title: 'Aviso',
          autoHideDelay: 2000,
          variant: 'success',
          appendToast: true
        })
      this.$router.go(-1)
      
    }
  }
  ,created() {
    this.usuario.login = window.localStorage.getItem('login')
  }
}
</script>



// WEBPACK FOOTER //
// src/views/pages/Senha.vue